import { render, staticRenderFns } from "./MatchingHome.vue?vue&type=template&id=5a51293e&scoped=true&"
import script from "./MatchingHome.vue?vue&type=script&lang=js&"
export * from "./MatchingHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a51293e",
  null
  
)

export default component.exports